import XHeader from 'vux/src/components/x-header/index.vue'
import Swipeout from 'vux/src/components/swipeout/swipeout.vue'
import SwipeoutItem from 'vux/src/components/swipeout/swipeout-item.vue'
import SwipeoutButton from 'vux/src/components/swipeout/swipeout-button.vue'

import attnIcon from 'assets/icons/icon_often_attn@3x.png'
import editIcon from 'assets/icons/icon_often_edit@3x.png'
import chooseIcon from 'assets/icons/icon-choose@3x.png'
import selectedIcon from 'assets/icons/icon-choose-selected@3x.png'
import { mapActions } from 'vuex'
import confirm from '../Common/Myconfirm.vue'

export default {
name: 'SportsTourPackageAddPeople',
components: {
XHeader,
Swipeout,
SwipeoutItem,
SwipeoutButton,
confirm,
},
data() {
return {
respTravelers: [],
attnIcon,
editIcon,
chooseIcon,
selectedIcon,
personCount: 0,
userId: 0,
certificateType: '',
sleletedTravelers: [],
}
},
props: ['attn', 'selected', 'type'],
watch: {
},
computed: {
},
methods: {
...mapActions(['showToast']),
deleteAttn(id) {
const req = {
optionTpye: 2,
travelerId: id,
}

this.$http.post('/api/travelerOption', req)
.then(() => {
this.$router.go(0)
})
.catch((err) => {
this.showToast({
content: err.body.resultInfo,
})
})
},
check(e, travelerId) {
let traveler
for (const index in this.respTravelers) {
if (this.respTravelers[index].id === travelerId) {
traveler = this.respTravelers[index]
break
}
}
for (let i = 0; i < this.certificateType.split('-').length; i += 1) {
switch (this.certificateType.split('-')[i]) {
case '1':
if (traveler.idCard === null || traveler.idCard === '') {
this.showConfirm(travelerId)
return
}
break

case '2':
if (traveler.passport === null || traveler.passport === '') {
this.showConfirm(travelerId)
return
}
break

case '3':
if (traveler.hkmpassport === null || traveler.hkmpassport === '') {
this.showConfirm(travelerId)
return
}
break
default:
}
}
let checkcount = 0
for (let i = 0; i < document.getElementsByName('gouimg').length; i += 1) {
if (document.getElementsByName('gouimg')[i].getAttribute('check') === 'true') {
checkcount += 1
}
}
if (e.currentTarget.childNodes[4].getAttribute('check') === 'true') {
e.currentTarget.childNodes[4].setAttribute('check', 'false')
e.currentTarget.childNodes[4].src = '/static/images/icons/gou_no.png'
} else if (checkcount >= this.personCount) {
this.showToast({
content: `最多只能添加${this.personCount}个出行人`,
size: '18em',
})
} else {
e.currentTarget.childNodes[4].setAttribute('check', 'true')
e.currentTarget.childNodes[4].src = '/static/images/icons/gou.png'
}
},
add() {
window.location.replace(`/h5/sportsTourRouteSavePeople/${this.userId}/${this.certificateType}/${this.personCount}`)
},
edit(id) {
for (const index in this.respTravelers) {
if (this.respTravelers[index].id === id) {
const traveler = this.respTravelers[index]

const gender = traveler.gender ? '男(male)' : '女(female)'

const idCard = traveler.idCard === '' ? 'null' : traveler.idCard
const passport = traveler.passport === '' ? 'null' : traveler.passport
const hkmpassport = traveler.hkmpassport === '' ? 'null' : traveler.hkmpassport

window.location.replace(`/h5/sportsTourRouteEditPeople/${traveler.travelerName}/${traveler.pinyinxing}/${traveler.pinyinming}/${gender}
/${idCard}/${passport}/${hkmpassport}/${this.userId}/${this.certificateType}/${id}/${this.personCount}`)
return
}
}
},
showCard(cardtype) {
for (let i = 0; i < this.certificateType.split('-').length; i += 1) {
if (cardtype === this.certificateType.split('-')[i]) {
return true
}
}
return false
},
confim(event) {
this.edit(event)
},
showConfirm(travelerId) {
this.$refs.myConfirm.show('信息不全，请补充', {
type: '2',
cancelText: '取消',
confirmText: '确认',
data: travelerId,
})
},
save() {
let checkcount = 0
for (let i = 0; i < document.getElementsByName('gouimg').length; i += 1) {
if (document.getElementsByName('gouimg')[i].getAttribute('check') === 'true') {
checkcount += 1
const sleletedtravelerId = document.getElementsByName('gouimg')[i].getAttribute('travelerId')
for (let j = 0; j < this.respTravelers.length; j += 1) {
if (this.respTravelers[j].id.toString() === sleletedtravelerId) {
this.sleletedTravelers.push(this.respTravelers[j])
break
}
}
}
}
if (checkcount < this.personCount) {
this.showToast({
content: `请选择${this.personCount}个出行人`,
size: '18em',
})
} else if (checkcount > this.personCount) {
this.showToast({
content: `最多只能添加${this.personCount}个出行人`,
size: '18em',
})
} else {
window.sessionStorage.setItem(`${this.userId + window.sessionStorage.getItem('routeId')}sleletedTravelers`, JSON.stringify(this.sleletedTravelers))
const sleletedTravelers = window.sessionStorage.getItem(`${this.userId + window.sessionStorage.getItem('routeId')}sleletedTravelers`)
console.log(JSON.parse(sleletedTravelers))
window.history.go(-1)
}
},
},
mounted() {
},
created() {
const { userId } = this.$jwt
this.userId = userId
this.personCount = this.$route.params.personCount
this.certificateType = this.$route.params.certificateType
const req = {
optionTpye: 4,
userId,
}

this.$http.post('/api/travelerOption', req).then(res => res.json())
.then((traveler) => {
this.respTravelers = traveler.respTravelers
})
.catch((err) => {
this.showToast({
content: err.body.resultInfo,
})
})
},
}



// WEBPACK FOOTER //
// ./client/components/SportsTour/SportsTourPackageAddPeople.vue